<template>
  <TwoColPageWrapper :breadcrumbs="breadcrumbs" :menuItems="menuItems" leftBanner>
    <div itemscope itemtype="http://schema.org/Article">
      <div
        itemprop="publisher"
        itemscope
        itemtype="https://schema.org/Organization"
        style="display:none"
      >
        <div
          itemprop="logo"
          itemscope
          itemtype="https://schema.org/ImageObject"
        >
          <img
            itemprop="image"
            src="local/templates/main/images/logo.png"
            alt="Логотип сайта"
          />
          <meta itemprop="width" content="50" />
          <meta itemprop="height" content="50" />
        </div>
        <meta itemprop="name" content="Sika" />
        <meta itemprop="telephone" content="+7 (495) 5 777 333" />
        <meta itemprop="address" content="Россия" />
      </div>

      <h1 itemprop="headline">{{ article.title }}</h1>
      <div itemprop="datePublished" class="news-full-date">
        {{ article.date }}
      </div>
      <div itemprop="articleBody" v-html="article.text">
        </div>
        <div style="clear:both;"></div>
        <p class="b-bottom-nav__main-category">
          <router-link :to="{ name: 'articles' }">Все статьи</router-link>
        </p>
      </div>

      <!-- <form
        id="subscribe_form"
        action="https://sikahome.ru/subscribe/"
        method="POST"
      >
        <div class="b-news-subscribe">
          <div class="b-news-subscribe__slogan">
            Хотите быть в курсе наших новостей<span> — </span>
          </div>

          <div class="b-news-subscribe__form">
            <input
              name="email"
              placeholder="подпишитесь на новости"
              type="text"
              class="b-news-subscribe__mail"
            />
            <div class="b-news-subscribe__send subscibe__send">></div>
          </div>

          <div style="clear: both;"></div>
          <p class="b-news-subscribe__form-politics">
            <input type="checkbox" id="question_personal" />
            <label for="question_personal"
              ><span></span> Я соглашаюсь с
              <a
                href="https://sikahome.ru/Politika-konfidentsialnosti-_Personalnye-dannye_.pdf"
                target="_blank"
                >Политикой конфиденциальности обработки персональных данных</a
              >
              и даю согласие на обработку своих персональных данных.
            </label>
          </p>
        </div>
      </form> -->
    </div>

    <p><a href="../index.html"></a></p>
  </TwoColPageWrapper>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
      breadcrumbs() {
          return [
        {
          label: "Главная",
          to: {name: "main"},
        },
        {
          label: "Статьи",
          to: {name: "articles"},
        },
        {
          label: this.article.title,
        },
      ]
      },
      menuItems() {
          return this.articles.items.map(article => {
              return {
          to: {name: 'article', params: {id: article.id}},
          name: article.title,
        }
          })
      },
    article() {
      return this.articles.items.find(
        (article) => article.id === parseInt(this.$route.params.id)
      );
    },
    ...mapState(["articles"]),
  },
};
</script>

<style lang="scss" scoped></style>
